import { Link } from "react-router-dom";
import { toDriveDirectUrl } from "@/lib/utils";

export interface Noticia {
  id: number;
  titulo: string;
  extracto?: string;
  imagen?: string;
  fecha?: string;
  comuna?: string;
  categoria?: string;
  segmento?: string;
  subtitulo?: string;
}

interface NoticiaPequenaCardProps {
  noticia: Noticia;
}

export default function NoticiaPequenaCard({ noticia }: NoticiaPequenaCardProps) {
  return (
    <div className="bg-white border border-masmed-gray-200 rounded-lg shadow-sm overflow-hidden flex flex-col h-full">
      {/* Título con línea naranja */}
      <div className="p-3 md:p-3.5 pb-2">
        <div className="flex items-start gap-2">
          <div className="w-1 h-5 md:h-6 bg-primary rounded-full flex-shrink-0 mt-0.5" />
          <h3 className="text-xs md:text-[13px] text-masmed-gray-900 leading-snug line-clamp-3"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}>
            {noticia.titulo}
          </h3>
        </div>
      </div>

      {/* Imagen */}
      <div className="flex-1 min-h-[80px] md:min-h-[100px] relative">
        <img
          src={toDriveDirectUrl(noticia.imagen || "")}
          alt={noticia.titulo}
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Botón Ver más debajo de la imagen */}
      <div className="px-3 md:px-4 py-2 md:py-2.5 flex justify-center">
        <Link
          to={`/noticias/${noticia.id}`}
          className="inline-flex items-center justify-center px-4 py-1 bg-primary text-white text-[11px] md:text-xs rounded hover:bg-primary-dark transition-colors duration-200 cursor-pointer"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}
        >
          Ver más
        </Link>
      </div>
    </div>
  );
}